module.exports = __webpack_public_path__ + "static/media/faq-selfie-ident.b1398511.svg";